// 引入 UnoCSS，保留旧 Windi 原子类的兼容规则
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入element-plus-icon
import { setupElementPlusIcon } from '@/plugins/elementPlusIcon'

// el-table-v2 滚轮吞噬修复（表格无余量时放行页面原生滚动）
import { installTableV2WheelScrollFix } from '@/utils/tableV2Wheel'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp, createSSRApp } from 'vue'

import {baseUrl } from '@/utils/publiConst'

import print from 'vue3-print-nb'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'






import App from './App.vue'



import './permission'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)



  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  setupElementPlusIcon(app)

  installTableV2WheelScrollFix()

  baseUrl(app)

  app.use(print)

  app.use(VXETable)

  if (process.env.NODE_ENV === "development") {
    app.config.globalProperties.$baseUrl = "http://zscrmdev.yejibao.vip"
  }else {
    app.config.globalProperties.$baseUrl = window.location.origin
  }
  



  app.mount('#app')





}

setupAll()
